import styled from '@emotion/styled';
import { Css, Responsive } from '@/ui';

export const QuickLinksGrid = styled.div`
	display: grid;
	grid-template-columns: repeat(3, 1fr);
	gap: ${Css.pxToRemFromTheme(8)};

	@media (${Responsive.getMediaQueryForBreakpoint('mobileXL')}) {
		grid-template-columns: repeat(1, 1fr);
		gap: ${Css.pxToRemFromTheme(16)};
	}
`;
